export const HIDDEN = -1;
export const NOT_AVAILABLE = 0;
export const AVAILABLE = 1;
